import PageList from "../abstract/PageList.js";
import { SecurityAcl, AuthCheckAcl } from "../../Security.js";
import AgGridWrapper from "../../su/AgGridWrapper.js";
import { ModalAlert, ModalConfirm } from "../../su/Modals.js";

export default class PageDMSList extends PageList {
    constructor() {
        super();
    }

    init($data) {
        super.init($data);
    }

    getAvailableHeight() {
        let a = jQuery(".js-size");
        let i = 0;
        for (let x = 0; x < a.length; x++) {
            i += jQuery(a[x]).outerHeight();
        }
        i += 50; // padding app container
        i += 78; // search box
        i += 143; // paging
        let h = jQuery(window).height() - i;
        return h;
    }

    initAgList() {
        const rowData = [];
        for (let x = 0; x < this.data.rows.length; x++) {
            const row = this.data.rows[x];
            rowData.push(row);
        }
        this.rowData = rowData;

        const searchBox = document.getElementById("filter-text-box");

        const targetGrid = document.querySelector(".js-aglist");
        const h = this.getAvailableHeight();
        targetGrid.style.height = h + "px";

        const columnDefs = [
            {
                field: "CustomerID",
                headerName: "Customer",
            },
            {
                field: "CustomerTradingName",
                headerName: "Ragione sociale"
            },
            {
                field: "VATNumber",
                headerName: "Partita IVA"
            },
            {
                field: "FiscalNumber",
                headerName: "Codice fiscale",
            },
            {
                field: "RecordDtInsert",
                headerName: "Data Creazione",
                type: AgGridWrapper.TYPE_DATE_LOCAL_STRING,
            },
            {
                field: "RecordDtUpdate",
                headerName: "Data Aggiornamento",
                type: AgGridWrapper.TYPE_DATE_LOCAL_STRING,
            },
            {
                field: "Action",
                sortable: false,
                type: AgGridWrapper.TYPE_CTA,
                flex: 0.5,

                actions: this.createActions(this)
            }
        ];

        // Inizializzazione della griglia (Copia incolla tranne il primo parametro che è un id arbitrario ma usiamo generalmente il nome della pagina)
        let agGrid = new AgGridWrapper("PageDMSUSersList", AgGridWrapper.MODE_SIMPLE);
        const options = agGrid.getConfig({
            paginationPageSize: 20,
            //onRowClicked: this.onRowClicked.bind(this),
            customOptions: {
                doNotshowSelection: true, // In modo casereccio non mostra la selezione
                removeOldList: false, // Rimuove la vecchia griglia dalla pagina (punta sul fatto che i nodi che la contengono si chiamino "jsList" e "filterbox" grazie al solito copia-incolla selvaggio).
            },
            columnDefs,
            rowData,
        });

        // Crea la griglia e ascolta il resize della finestra per cambiare l'altezza
        agGrid.init(targetGrid, searchBox, options);
        window.onresize = this.arrangeGrid.bind(this, agGrid);
    }

    arrangeGrid(agGrid) {
        // Punta alla griglia e ne imposta l'altezza
        const h = this.getAvailableHeight();
        agGrid.targetGrid.style.height = h + "px";
    }

    createActions(p) {
        let actions = [
            {
                hasPermission: this.hasPerm.bind(this),
                type: AgGridWrapper.CTA_VIEW,
                callback: this.viewRow.bind(p),
            },
            {
                hasPermission: this.hasPerm.bind(this),
                type: AgGridWrapper.CTA_DELETE,
                callback: this.deleteRow.bind(p),
            }
        ];

        return actions;

    }

    hasPerm(params, action) {
        let SUid = params.node.data.SUid;

        if (AgGridWrapper.CTA_DELETE == action) {
            return this.aclContext.HasGrantedAcl(new AuthCheckAcl(SUid, SecurityAcl.ACL_DELETE));
        }
        else if (AgGridWrapper.CTA_VIEW == action) {
            return this.aclContext.HasGrantedAcl(new AuthCheckAcl(SUid, SecurityAcl.ACL_READ));
        }

        return true;
    }

    viewRow(params) {
        document.location.href = TheApp.Env.BaseUrlNls + "dms/detail/" + Base64.toBase64(params.data.Uid, true) + "?__pi=" + this.data.page.PageId;
    }

    deleteRow(params) {
        let modal = new ModalConfirm($("#template-modalConfirm"));
        modal.create(
            {
                title: "Conferma cancellazione",
                body: "Sei sicuro di voler rimuovere definitivamente questo elemento? Non puoi annullare questa azione.",
                yes: "SI",
                no: "NO",
                danger: true // viene il pulsante rosso, altrimenti blue
            }, this.onConfirmDelete.bind(this, params));
        modal.init();
    }

    onConfirmDelete(params, bConfirm) {
        if (bConfirm) {
            this.showPreloader(true);
            let rq = {
                Value: params.data.Uid
            }
            thatServiceManeger.standardCall(this.data.serviceDeleteRoute + this.data.tableUid, rq, this.onDeleteServiceHandler.bind(this, params));

        }
    };

    onDeleteServiceHandler(params,rs) {
        this.showPreloader(false);

        //
        if (rs.Success) {
            //this.theGrid.deleteByDataIndex(dataIndex);
            let modal = new ModalAlert($("#template-modalAlert"));
            modal.create(
                {
                    title: "Successo",
                    body: "Cancellazione terminata correttamente!",
                    close: "CHIUDI",
                    error: false
                });
            modal.init();
            /// rimuove il record dalla tabella
            params.api.applyTransaction({ remove: [params.data] });
        } else {
            let error = null;
            if (rs.hasOwnProperty('Errors') && rs.Errors !== null && rs.Errors.length >= 0) {
                error = TheApp.Res[TheApp.Locale]["ERROR." + rs.Errors[0].Code];
                if (rs.Errors[0].RefsUid.length > 0) {
                    error = error.replace("{0}", rs.Errors[0].RefsUid);
                }
            }
            if (!error)
                error = TheApp.Res[TheApp.Locale]["ERROR.HTTP." + rs.StatusCode];
            if (!error)
                error = TheApp.Res[TheApp.Locale]["ERROR.HTTP.DEFAULT"];
            let modal = new ModalAlert($("#template-modalAlert"));
            modal.create(
                {
                    title: "Si è verificato un'errore",
                    body: error,
                    close: "CHIUDI",
                    error: true
                });
            modal.init();
        }
        //this.showPreloader(false);
    }

   

}

